export const iconFontAwesomeEmojiFaceGrinBeamSweat = (
	<i className="fa-solid fa-face-grin-beam-sweat"></i>
);
